import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/GetStartedCompanyAdmin';
// FOR ONE GRAPHQL QUERY
export const FETCH_COMPANY_VERSION = defineAsyncActionTypes(`${prefix}/FETCH_COMPANY_VERSION`);
export const SET_GET_STARTED_STATUS = defineAsyncActionTypes(`${prefix}/SET_GET_STARTED_STATUS`);
export const GET_COMPANY_DETAILS = defineAsyncActionTypes(`${prefix}/GET_COMPANY_DETAILS`);
